import React from 'react';
import { useAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { annotationsFeatureSelector } from '@store/common/selectors';
import { annotationAtom } from '@src/atoms/toggles';

const AnnotationToggle = () => {
  const annotationsFeatureFlag = useSelector(annotationsFeatureSelector);
  const [annotationsToggle, setAnnotationsToggle] = useAtom(annotationAtom);

  if (!annotationsFeatureFlag) {
    return null;
  }

  const label = annotationsToggle ? 'Disable' : 'Enable';

  return (
    <div onClick={() => setAnnotationsToggle(!annotationsToggle)}>
      <span>{`${label} Annotations`}</span>
    </div>
  );
};

export default AnnotationToggle;
